import { createSlice } from "@reduxjs/toolkit";

let initialState = {
    dispatchRef: null,
    appConfig: null,
    _checkoutPopUp: null,
    _loginModalRef: null,
    closeAccordians: null,
    _closetModalRef: null,
    _outfitModalRef: null,
    _countryModalRef: null,
    _currencyModalRef: null,
};

export const utilsSlice = createSlice({
    name: "utils",
    initialState,
    reducers: {
        setDispatchRef: (state, action) => {
            state.dispatchRef = action.payload;
        },
        setCheckoutPopUpRef: (state, action) => {
            state._checkoutPopUp = action.payload;
        },
        setLoginModalRef: (state, action) => {
            state._loginModalRef = action.payload;
        },
        setClosetAccordians: (state, action) => {
            state.closeAccordians = action.payload;
        },
        resetUtilsSlice: (state) => {
            state.appConfig = initialState.appConfig;
        },
        setClosetModalRef: (state, action) => {
            state._closetModalRef = action.payload;
        },
        setOutfitModalRef: (state, action) => {
            state._outfitModalRef = action.payload;
        },
        setCountryModalRef: (state, action) => {
            state._countryModalRef = action.payload;
        },
        setCurrencyModalRef: (state, action) => {
            state._currencyModalRef = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

export const {
    setDispatchRef,
    setCheckoutPopUpRef,
    setLoginModalRef,
    resetUtilsSlice,
    setClosetAccordians,
    setClosetModalRef,
    setOutfitModalRef,
    setCountryModalRef,
    setCurrencyModalRef,
} = utilsSlice.actions;

export default utilsSlice.reducer;
